import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AionzTooltip } from '@aionzdev/design-system';

import { ApprovalReviewData } from '../../../interfaces/approval-review';

/**
 * Revisão do que vai ser aprovado: resumo, critério da escolha, alertas e, por fornecedor, os
 * itens com cotado, negociado, concorrência, frete e economia. Somente leitura e sem botões:
 * quem usa coloca as ações.
 *
 * - `revisao`: no modal do mapa, antes de mandar para aprovação (o resumo fica preso no topo
 *   enquanto a lista rola dentro do modal).
 * - `aprovacao`: na tela de aprovação, para quem aprova.
 */
@Component({
  selector: 'aionz-approval-review',
  imports: [AionzTooltip, MatIconModule, CurrencyPipe, DatePipe, DecimalPipe, PercentPipe],
  templateUrl: './approval-review.component.html',
  styleUrl: './approval-review.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.modo-revisao]': "modo() === 'revisao'",
    '[class.modo-aprovacao]': "modo() === 'aprovacao'"
  }
})
export class ApprovalReviewComponent {
  readonly review = input.required<ApprovalReviewData>();
  readonly modo = input<'revisao' | 'aprovacao'>('revisao');

  protected readonly itemsLabel = computed(() => {
    const { selectedItemsCount, itemsTotal } = this.review();
    return `${selectedItemsCount} de ${itemsTotal} ${itemsTotal === 1 ? 'item' : 'itens'}`;
  });

  /** Itens que ficam de fora: no mapa, sem seleção; na aprovação, sem cotação aguardando. */
  protected readonly unselectedLabel = computed(() => {
    const one = this.review().unselectedItems.length === 1;
    if (this.modo() === 'aprovacao') {
      return one ? 'item ficou fora desta aprovação' : 'itens ficaram fora desta aprovação';
    }
    return one ? 'item sem seleção não será aprovado' : 'itens sem seleção não serão aprovados';
  });
}
